import Overlay from 'src/designSystem/components/organisms/Overlay/variants/OverlaySimple'

// the default Overlay/Overlay uses the OverlaySimple variant for backwards compatibility
// you can also use variants in Overlay/variants/ directly
export default Overlay
